import expiringLicense from './ConfigCatalog/expiring-license';
import g1Environment from './ConfigCatalog/g1-environment';
import proxyLogin from './ConfigCatalog/proxy-login';
import twoFAUser from './ConfigCatalog/2FA/two-fa-enablement-user';
import twoFAAdmin from './ConfigCatalog/2FA/two-fa-enablement-admin';
import emailVerification from './ConfigCatalog/EmailVerification/email-verification';

const configRegistry = [
  expiringLicense,
  g1Environment,
  proxyLogin,
  twoFAUser,
  twoFAAdmin,
  emailVerification,
];

const configMap = configRegistry.reduce(
  (currentConfigMap, config) => ({
    ...currentConfigMap,
    [config.messageId]: config,
  }),
  {},
);

export const getConfig = (messageId) => {
  return configMap[messageId];
};
